import { Facebook, LinkedIn, Twitter } from '@mui/icons-material'

export const navItems = [
  {
    path: '/',
    title: 'Home',
  },
  {
    id: 'menu-button',
    title: 'Services',
    submenu: [
      {
        path: '/products',
        title: 'Products',
      },
      {
        path: '/system-solutions',
        title: 'System Solutions',
      },
      {
        path: '/gis-solutions',
        title: 'GIS Solutions',
      },
      {
        path: '/traffic-simulation',
        title: 'Traffic Simulation',
      },
    ],
  },
  {
    path: '/about-us',
    title: 'About Us',
  },
  {
    path: '/contact',
    title: 'Contact',
  },
]

export const footerLinks = [
  {
    title: 'Social Media',
    links: [
      {
        icon: <Facebook />,
        text: 'Facebook',
        aHref: true,
        path: 'https://www.facebook.com/',
      },
      {
        icon: <LinkedIn />,
        text: 'LinkedIn',
        aHref: true,
        path: 'https://www.linkedIn.com/',
      },
      {
        icon: <Twitter />,
        text: 'Twitter',
        aHref: true,
        path: 'https://www.twitter.com/',
      },
    ],
  },
  {
    title: 'Quick Links',
    links: [
      {
        text: 'Home',
        path: '/',
      },
      {
        text: 'About us',
        path: '/about-us',
      },
      {
        text: 'Services',
        path: '/products',
      },
      {
        text: 'Contact',
        path: '/contact',
      },
    ],
  },
  {
    title: 'Location',
    links: [
      {
        text: 'InfoGIS',
        plainText: true,
      },
      {
        text: 'Dardani, Prishtinë',
        aHref: true,
        path: 'https://goo.gl/maps/WFEv1jEL5oS5YwB3A',
      },
      {
        text: 'Tel: +383 48 148557',
        aHref: true,
        path: 'tel:+38348148557',
      },
      {
        text: 'Mail: info@infogis.net',
        aHref: true,
        path: 'mailto:info@infogis.net',
      },
    ],
  },
]
